// import Tooltip from '@mui/material/Tooltip';
import useMediaQuery from '@mui/material/useMediaQuery';
import makeStyles from '@mui/styles/makeStyles';
import PropTypes from 'prop-types';
import React from 'react';
import InfoTooltipWithLink from 'react/shared/components/tooltips/InfoTooltipWithLink';
import NameFields from 'react/shared/components/true_link/lab/form/NameFields';
import TrueLinkMaskedTextInput from 'react/shared/components/true_link/lab/form/TrueLinkMaskedTextInput';
import AddressFields from 'react/shared/components/true_link/lab/form/address_input/AddressFields';
import CountryOfCitizenship from 'react/shared/components/true_link/lab/form/country_of_citizenship/CountryOfCitizenship';
import CardText from 'react/shared/components/true_link/lab/form/wizard/CardText';
import { mediumBreakpointMediaQuery } from 'react/shared/theme/Theme';
import cardholderProfileShape from 'react/signups/card/shapes/CardholderProfile';

const useStyles = makeStyles(() => ({
  profileForm: {
    marginBottom: '4rem',
  },
  tooltipText: {
    borderBottom: '1px dashed #BDBDBD',
  },
}));
export default function CardholderProfileForm({
  onChange,
  onSkip,
  setFieldTouched,
  setValues,
  values,
}) {
  const classes = useStyles();
  const desktop = useMediaQuery(mediumBreakpointMediaQuery);
  const countryOfCitizenshipFlag = $tlf?.flipperEnableCountryOfCitizenship;
  const countryOfCitizenshipLabel = `Their country of citizenship`;
  const nonResidentAlienLabel = `Are they a non-resident alien?`;

  const tooltipText = `
    If you are ordering multiple cards, you can skip ordering now and our team will help with a bulk upload.`;

  const tooltipLinkId = 'skip-card-ordering';

  const tooltipLinkText = `
    <br /><br />
    <span id="${tooltipLinkId}" style="display: block; text-decoration: underline; cursor: pointer; color: #0077CC">
        Skip card ordering for now
      </span>
  `;

  return (
    <>
      <CardText>
        <span>Start by telling us about one of the cardholders you’re ordering a card for. </span>
        <InfoTooltipWithLink
          childId="multi-select"
          clickHide
          id="skip-card-ordering-tooltip"
          placement="bottom"
          tooltipLinkCallback={onSkip}
          tooltipLinkId={tooltipLinkId}
          tooltipStyle="width: 320px"
          tooltipTextWithLink={tooltipText + tooltipLinkText}
        >
          <span className={classes.tooltipText} id="multi-select">
            Ordering more than 5 cards? Our team can help.
          </span>
        </InfoTooltipWithLink>
      </CardText>
      <NameFields
        labelPrefix="Cardholder"
        onChange={onChange}
        setFieldTouched={setFieldTouched}
        values={values}
      />
      <AddressFields
        labelPrefix="Cardholder"
        setFieldTouched={setFieldTouched}
        setValues={setValues}
        showPoBoxWarning
        values={values}
      />
      {countryOfCitizenshipFlag && (
        <CountryOfCitizenship
          countryOfCitizenshipLabel={countryOfCitizenshipLabel}
          nonResidentAlienLabel={nonResidentAlienLabel}
          onChange={onChange}
          required
          setFieldTouched={setFieldTouched}
          values={values}
        />
      )}
      <TrueLinkMaskedTextInput
        labelText="Their date of birth"
        mask="99/99/9999"
        name="dateOfBirth"
        onChange={onChange}
        placeholder="MM/DD/YYYY"
        required
        setFieldTouched={setFieldTouched}
        value={values.dateOfBirth}
      />
      <TrueLinkMaskedTextInput
        className={!desktop ? classes.profileForm : ''}
        labelText="Their phone number (Optional)"
        mask="999-999-9999"
        name="mobile"
        onChange={onChange}
        placeholder="(555) 555 - 5555"
        required={false}
        setFieldTouched={setFieldTouched}
        value={values.mobile}
      />
    </>
  );
}

CardholderProfileForm.propTypes = {
  onChange: PropTypes.func.isRequired,
  onSkip: PropTypes.func.isRequired,
  setFieldTouched: PropTypes.func.isRequired,
  setValues: PropTypes.func.isRequired,
  values: cardholderProfileShape.isRequired,
};
